import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import { Ticket } from "../../types";
import { formatDate, formatRelativeDate } from "../../utils";

interface TicketTimestampsProps {
  ticket: Ticket;
}

export default function TicketTimestamps({ ticket }: TicketTimestampsProps) {
  return (
    <DSBox>
      <DSTypography variant="caption" sx={{ color: "text.secondary" }}>
        {ticket.key} &middot; Created {formatDate(ticket.createdAt)} &middot;
        Updated {formatRelativeDate(ticket.updatedAt)}
        {ticket.resolvedAt &&
          ` · Resolved ${formatRelativeDate(ticket.resolvedAt)}`}
      </DSTypography>
    </DSBox>
  );
}
